var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@material-ui/core';
import { TurnIcon } from '@timeflies/app-ui';
import { TimeCounter, TimeGauge } from '@timeflies/time-gauge-panel';
import React from 'react';
import { FeedbackContainer } from './feedback-container';
export var FeedbackTurn = function (props) {
    return React.createElement(FeedbackContainer, { left: React.createElement(Box, { display: 'flex', p: 0.5 },
            React.createElement(TurnIcon, __assign({}, props))), right: React.createElement(Box, { mr: 0.5 },
            React.createElement(TimeCounter, __assign({}, props))), bottom: React.createElement(Box, { width: '100%', p: 0.25 },
            React.createElement(TimeGauge, __assign({}, props))) });
};
